import { FC } from 'react';

import InfiniteCarousel from 'molecules/InfiniteCarousel';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import { TestimonialsConfigProps } from 'components/Testimonials/config';

import { hasArrayValues } from 'utils/array/arrays';

const Testimonials: FC<TestimonialsConfigProps> = ({ testimonials, ...props }) => {
  const { sectionProps } = splitSectionProps(props);

  return (
    <Section {...sectionProps}>
      {hasArrayValues(testimonials) && (
        <InfiniteCarousel component="testimonialCard" slides={testimonials} spacing="50px" />
      )}
    </Section>
  );
};

export default Testimonials;
